import React from "react";
import "./PlanTripSection.css";

const PlanTripSection = () => {
  return (
    <div className="plan-main">
      <h1 className="plan-heading">How To Plan a Trip</h1>

      <ul className="plan-list">
        <li>Choose Destination And Theme</li>
        <li>Decide your Travel Days (Weekend / Long trip)</li>
        <li>Decide your Budget</li>
        <li>Compare Packages on ZikRme</li>
        <li>Customize if needed</li>
        <li>Book later or Plan yourself</li>
      </ul>
    </div>
  );
};

export default PlanTripSection;
